
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-creators",
      function () {
        return require("private-next-pages/for-creators.tsx");
      }
    ]);
  